import { useCallback } from "react";
import { useBulkActions } from "@components/transactions/TransactionsBulkActions/useBulkActions";
import { AddToChatButton } from "../../AddToChatButton";
import { useAddTransactionsToChat } from "../../useAddReferencesToChat";

export const TransactionsTaskAskButton: React.FC = () => {
    const { canAddToChat, addTransactionsToChat } = useAddTransactionsToChat();
    const { selectedArray, hasSelectedAll, clearSelection } = useBulkActions();

    const handleAttach = useCallback(() => {
        if (hasSelectedAll) {
            return;
        }
        addTransactionsToChat(selectedArray);
        clearSelection();
    }, [addTransactionsToChat, selectedArray, hasSelectedAll, clearSelection]);

    if (!canAddToChat || selectedArray.length === 0) {
        return null;
    }

    return (
        <AddToChatButton
            noun="transaction"
            count={selectedArray.length}
            onClick={handleAttach}
            disabledReason={
                hasSelectedAll
                    ? "Select specific transactions to add them to chat"
                    : undefined
            }
        />
    );
};
